// extracted by mini-css-extract-plugin
export default {"root":"DealsItem_root__nwbTu","root_title":"DealsItem_root_title__JdbMe","root_subTitle":"DealsItem_root_subTitle__Aj70h","statusBlock":"DealsItem_statusBlock__Ghpr+"};